import { useDependencies } from '@servicetitan/react-ioc';
import { observer } from 'mobx-react';
import { FC, PropsWithChildren } from 'react';
import { Redirect } from 'react-router-dom';

import {
    MarketingMainSettingsRoutes,
    MarketingMfe,
    MarketingRouteStore,
    MarketingSection,
    MfeBasenames,
} from '@servicetitan/marketing-global-route';
import { StandaloneRootStore } from '@servicetitan/standalone-root';
import { OnboardingBrandState } from '@servicetitan/marketing-services-api/dist/settings';

export const IfOnboarded: FC<PropsWithChildren> = observer(({ children }) => {
    const [{ onboarding }, { getPathnameWithStandaloneRoot }] = useDependencies(
        StandaloneRootStore,
        MarketingRouteStore,
    );

    if (onboarding.state !== OnboardingBrandState.Completed) {
        return (
            <Redirect
                to={getPathnameWithStandaloneRoot(
                    MarketingSection.Settings,
                    `${MfeBasenames[MarketingMfe.MainSettings]}${MarketingMainSettingsRoutes.SettingsBrand}`,
                )}
            />
        );
    }

    return children;
});
